import { render, staticRenderFns } from "./AppBanner.vue?vue&type=template&id=1128d803&"
import script from "./AppBanner.vue?vue&type=script&lang=ts&"
export * from "./AppBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports